import http from '@/services/common/http-service';
import axios from 'axios';
import { Err, Ok } from 'ts-results';
export class SampleDataService {
    async Get(layerId) {
        try {
            const { data, status } = await http.get('/Data/Sample/' + layerId);
            return Ok(data);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return Err('error message: ' + error.message);
            }
            return Err('unexpected error: ' + error);
        }
    }
}
